import { Option } from 'baseui/select';
import stylesColors from 'common/styles/styles.colors';
import { themedStyled } from 'common/styles/styletron.theme';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { TextLabelPlacementEnum } from 'components/elements/custom-form-control';
import Text from 'components/elements/text';
import HotelSelectInput from 'legacy-modules/master/hotel/components/select-input';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  SectionContainer as RawSectionContainer,
  RowBetweenStyles,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import HotelRescheduleAddOnsTable from './add-ons-table';
import HotelRescheduleGuestTable from './guest-table';
import NewHotelTable from './new-hotel-table';
import OriginalHotelSaleHotel from './original-hotel-table';
import { ScheduleCardHeader, ScheduleCardHeaderLeft } from '../../style';
import { HotelRescheduleFormType } from '../form-type';

interface Props {
  parentIndex: number;
}

function transformer(item: any): Option {
  return {
    id: item.id,
    label: `${item.type} (${item.size})`,
  };
}
const name = 'hotelSales' as const;
export default function HotelRescheduleItemCard(props: Props) {
  const { t } = useTranslation();
  const { setValue, control } = useFormContext<HotelRescheduleFormType>();
  const [hotelRooms, setHotelRooms] = React.useState<Option[]>([]);
  const parentName = `${name}.${props.parentIndex}` as const;
  const hotelSale = useWatch({
    control,
    name: parentName,
  });

  return (
    <CardSection>
      <ScheduleCardHeader>
        <ScheduleCardHeaderLeft>
          <Input
            type="check-box"
            name={`hotelSales.${props.parentIndex}.isSelected`}
            label={t('ticketSales:schedule_extra', {
              extra: props.parentIndex + 1,
            })}
          />
          <Input
            type="text"
            name={`${parentName}.bookingCode`}
            label={t('common:booking_code')}
            labelPlacement={TextLabelPlacementEnum.Left}
            placeholder={t('common:booking_code')}
            noMargin
            disabled
          />
        </ScheduleCardHeaderLeft>
      </ScheduleCardHeader>

      <Separator gap={16} />
      <SectionContainer>
        <HalfContainer>
          <HotelSelectInput
            name={`${parentName}.hotelId`}
            label={t('common:hotel')}
            onAfterDetailChange={(hotel) => {
              setHotelRooms(
                hotel.hotelRooms.map((hotelRoom) => transformer(hotelRoom)),
              );
              setValue(
                //@ts-ignore
                `${parentName}.hotelName`,
                hotel.name,
              );
              setValue(
                //@ts-ignore
                `${parentName}.hotelPhone`,
                hotel.phone,
              );
              setValue(
                //@ts-ignore
                `${parentName}.hotelEmail`,
                hotel.email,
              );
              setValue(
                //@ts-ignore
                `${parentName}.hotelAddress`,
                hotel.address,
              );
            }}
            disabled
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <FullContainer $style={RowBetweenStyles}>
            <FullContainer>
              <Input
                type="text"
                name={`${parentName}.hotelPhone`}
                label={t('common:phone_number')}
                disabled
              />
            </FullContainer>
            <Separator gap={16} />
            <FullContainer>
              <Input
                type="email"
                name={`${parentName}.hotelEmail`}
                label={t('common:email')}
                disabled
              />
            </FullContainer>
          </FullContainer>
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name={`${parentName}.hotelAddress`}
            label={t('common:address')}
            disabled
          />
        </HalfContainer>
      </SectionContainer>
      <HotelRescheduleGuestTable parentIndex={props.parentIndex} />
      <Separator gap={8} />

      <Separator gap={16} direction="vertical">
        <Text
          variant="LabelMedium"
          $style={{ color: stylesColors.primaryDefault }}
        >
          {t('common:original_extra', { extra: t('common:schedule') })}
        </Text>
      </Separator>
      <OriginalHotelSaleHotel parentIndex={props.parentIndex} />
      <Separator gap={8} />

      {hotelSale.isSelected && (
        <>
          <Separator gap={16} direction="vertical">
            <Text
              variant="LabelMedium"
              $style={{ color: stylesColors.primaryDefault }}
            >
              {t('common:new_extra', { extra: t('common:schedule') })}
            </Text>
          </Separator>
          <NewHotelTable
            hotelRooms={hotelRooms}
            parentIndex={props.parentIndex}
          />
        </>
      )}

      <HotelRescheduleAddOnsTable parentIndex={props.parentIndex} />
      <Separator gap={16} />
      <SectionContainer>
        <HalfContainer>
          <Input
            type="check-box"
            name={`${parentName}.isCityTax`}
            label={t('common:city_tax')}
            noMargin
            disabled
          />
          <Input
            type="text"
            name={`${parentName}.cityTax`}
            placeholder={t('common:city_tax')}
            disabled
            hideRequiredStar
            min={0}
          />
        </HalfContainer>
      </SectionContainer>
    </CardSection>
  );
}

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
